{
  "name": "@wayke-se/ecom-web",
  "version": "1.8.4",
  "description": "Wayke Ecom Web",
  "type": "module",
  "module": "dist/index.mjs",
  "main": "dist/index.js",
  "types": "dist/index.d.ts",
  "homepage": "https://github.com/wayke-se/wayke-ecom-web",
  "scripts": {
    "start": "node ./esbuild/start.js",
    "clip": "node ./esbuild/clip-ui.js && node ./clip-ui/start.js",
    "build": "npm run clean && node ./esbuild/lib.js && node ./esbuild/cdn.js",
    "clean": "rimraf build && rimraf dist && rimraf dist-cdn",
    "test": "npm run lint && npm run typecheck",
    "typecheck": "tsc -noEmit",
    "typecheck:watch": "tsc -noEmit -watch",
    "lint": "npx @biomejs/biome check",
    "lint:fix": "npx @biomejs/biome check --write",
    "stylelint": "stylelint '**/*.scss'",
    "prepare": "husky"
  },
  "author": "Wayke",
  "license": "ISC",
  "lint-staged": {
    "*.{js,ts}": [
      "npx @biomejs/biome check"
    ]
  },
  "devDependencies": {
    "@biomejs/biome": "^1.9.3",
    "@ourstudio/clip-ui": "^0.0.11",
    "@types/node": "^22.7.6",
    "@types/object-path": "^0.11.1",
    "@types/sanitize-html": "^2.6.2",
    "@types/showdown": "^2.0.6",
    "@typescript-eslint/eslint-plugin": "^8.9.0",
    "@typescript-eslint/parser": "^8.9.0",
    "esbuild": "^0.24.0",
    "esbuild-sass-plugin": "^3.3.1",
    "husky": "^9.0.11",
    "lint-staged": "^15.4.1",
    "npm-dts": "^1.3.11",
    "rimraf": "^6.0.1",
    "stylelint": "^16.2.1",
    "stylelint-config-prettier-scss": "^1.0.0",
    "stylelint-config-standard-scss": "^13.0.0",
    "typescript": "^5.1.3"
  },
  "dependencies": {
    "@wayke-se/ecom": "^4.5.0",
    "i18next": "^24.2.1",
    "object-path": "^0.11.8",
    "redux": "^5.0.1",
    "sanitize-html": "^2.7.0",
    "showdown": "^2.1.0"
  },
  "files": [
    "dist"
  ]
}
